"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTheme = createTheme;

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _units = require("./units");

var _colors = require("./colors");

var _breakpoints = require("./breakpoints");

var _grid = require("./grid");

var _keyframes = require("./keyframes");

var _typography = require("./typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Default theme.
 */
var defaultTheme = {
  baseUnit: _units.baseUnit,
  colors: _colors.colors,
  grid: _grid.grid,
  keyframes: _keyframes.keyframes,
  typography: _typography.typography
};
/**
 * Export `createTheme`.
 */

function createTheme(themeConfig) {
  var breakpoints = themeConfig.breakpoints,
      rest = _objectWithoutProperties(themeConfig, ["breakpoints"]);

  var theme = (0, _merge2.default)({}, defaultTheme, rest);
  return _objectSpread({}, theme, {
    breakpoints: !(0, _isEmpty2.default)(breakpoints) ? breakpoints : _breakpoints.breakpoints
  });
}